'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.cjs');
var MetaplexError = require('../../errors/MetaplexError.cjs');

/** @group Errors */
class DerivedIdentityError extends MetaplexError.MetaplexError {
  constructor(message, cause) {
    super(message, 'plugin', 'Derived Identity', cause);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'DerivedIdentityError');
  }
}

/** @group Errors */
class UninitializedDerivedIdentityError extends DerivedIdentityError {
  constructor() {
    const message = 'The derived identity module has not been initialized. ' + 'Before using the derived identity, you must provide a message that ' + 'will be used to derived a Keypair from the current identity. ' + 'You may do that by calling "metaplex.derivedIdentity().deriveFrom(message)".';
    super(message);
  }
}

exports.DerivedIdentityError = DerivedIdentityError;
exports.UninitializedDerivedIdentityError = UninitializedDerivedIdentityError;
//# sourceMappingURL=errors.cjs.map
